import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import profileImage from "../../images/bg-remove.png";
//import ProgressBar from "../progressBar/progressBar";
import "./AboutMe.css";
const AboutMe = () => {
  const testData = [
    { bgcolor: "#73DFC9", completed: 95, title: "Web-Design" },
    { bgcolor: "#FDD778", completed: 86, title: "Javascript" },
    { bgcolor: "#FF4C60", completed: 83, title: "ReactJs" },
    { bgcolor: "#6C6CE5", completed: 90, title: "NodeJs" },
  ];
  return (
    <div>
      <Container>
        <Row className="mt-5">
          <Col
            xs={12}
            lg={6}
            className="d-flex flex-column justify-content-center align-items-center"
          >
            <Card className="pt-4 d-flex justify-content-center align-items-center card-style shadow-lg">
              <Image
                className="mb-3"
                src={profileImage}
                width={150}
                roundedCircle
              />
              <div className="rounded-lg w-75">
                <p
                  style={{ fontFamily: "Montserrat, sans-serif" }}
                  className="text-decoration-none text-muted font-weight-light "
                >
                  A self-motivated and passionate web developer seeking a
                  position in a well-established company where I would be able
                  to utilize my knowledge as well as get the opportunity to
                  learn and grow, while serving the community for the better.
                </p>
                <a
                  className="mb-3 text-decoration-none mt-1 d-flex justify-content-center align-items-center"
                  href="https://drive.google.com/uc?export=download&id=1ZA7yVnTlwwV4zV8mavRxSHmAz1kGDKky"
                  download
                >
                  <Button
                    className="font-weight-light text-uppercase btn-main"
                    style={{
                      backgroundColor: "var(--main-button)",
                      borderStyle: "hidden",
                    }}
                  >
                    <small
                      style={{ fontFamily: "Montserrat, sans-serif" }}
                      className="font-weight-bold"
                    >
                      <FontAwesomeIcon className="mr-1" icon={faDownload} />
                      Get Resume
                    </small>{" "}
                  </Button>
                </a>
              </div>
            </Card>
          </Col>
          <Col xs={12} lg={6} >
            {/* {testData.map((item, idx) => (
              <ProgressBar
                key={idx}
                bgcolor={item.bgcolor}
                completed={item.completed}
                title={item.title}
              />
            ))} */}
            {/* <h3 className="text-center">MY Skills</h3> */}
            <div className="comfortable pt-3 card-style">
               <h4 className="text-center font-weight-lighter bg-white" 
               style={{color:"#73dfc9",  fontFamily: `"Bebas Neue", cursive`, letterSpacing:"1px"}}>Comfortable</h4>
              <ul>
                <li className="comfortable-list">React.js</li>
                <li className="comfortable-list">JavaScript</li>
                <li className="comfortable-list">MongoDB</li>
                <li className="comfortable-list">React Bootstrap</li>
                <li className="comfortable-list">REST API</li>
                <li className="comfortable-list">React Hooks</li>
                <li className="comfortable-list">React Router</li>
                <li className="comfortable-list">HTML</li>
                <li className="comfortable-list">CSS</li>
              </ul>
            </div>
            <div className="familiar">
            <h4 className="text-center font-weight-lighter bg-white" 
               style={{color:"#fdd778",  fontFamily: `"Bebas Neue", cursive`, letterSpacing:"1px"}}>Familiar</h4>
              <ul>
                <li className="familiar-list">Node.js</li>
                <li className="familiar-list">Express.js</li>
                <li className="familiar-list">Material UI</li>
                <li className="familiar-list">SASS</li>
                <li className="familiar-list">JAVA</li>
                <li className="familiar-list">C/C++</li>
                <li className="familiar-list">OOP</li>
                <li className="familiar-list">JSON</li>
              </ul>
            </div>
            <div className="tools">
            <h4 className="text-center font-weight-lighter bg-white" 
               style={{color:"#ff4c60",  fontFamily: `"Bebas Neue", cursive`, letterSpacing:"1px"}}>Tools</h4>
              <ul>
                <li className="tools-list">Firebase</li>
                <li className="tools-list">Netlify</li>
                <li className="tools-list">GitHub</li>
                <li className="tools-list">VS Code</li>
                <li className="tools-list">Heroku</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutMe;
